import { useState } from "react";
import useSWR from "swr";
import { useAuth } from "../../auth/AuthContext";
import Skeleton from "../../components/Skeleton";

// Sub-components matching Dashboard Design
import OverviewHero from "../../components/dashboard/OverviewHero";
import MostAffectedNationsSection from "../../components/dashboard/MostAffectedNationsSection";
import RansomwareSection from "../../components/dashboard/RansomwareSection";

import "../../styles/admin-dashboard.css";

import {
  fetchTimeline,
  fetchNations,
} from "../../api/status";

export default function ClientDashboard() {
  const { user } = useAuth();
  const [nationsTimeframe, setNationsTimeframe] = useState<string>("30d");

  // Global Timeline data
  const { data: timelineEntries, error: timelineError } = useSWR(
    user ? ['timeline', '14d'] : null,
    () => fetchTimeline({ days: 14 }),
    { refreshInterval: 60000, keepPreviousData: true }
  );

  // Nations data
  const { 
    data: nationsData, 
    error: nationsError, 
    isLoading: nationsLoading,
    isValidating: nationsValidating
  } = useSWR(
    user ? ['nations', nationsTimeframe] : null,
    () => fetchNations({ timeframe: nationsTimeframe }),
    { refreshInterval: 60000, keepPreviousData: true }
  );

  const userName =
    user?.name || (user?.email ? user.email.split("@")[0] : "Digvijay");

  // Only show full skeleton on initial global load
  if (!timelineEntries && !timelineError && !nationsData && !nationsError) {
    return (
      <div className="client-dashboard">
        <div className="dash-container">
          <div className="dash-body">
            <Skeleton rows={8} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="client-dashboard">
      <div className="dash-container">
        <div className="dash-body">
          {/* ── PHASE 1 TOP HERO: GREETING + 7-DAY SUMMARY + 14-DAY INCIDENT BAR CHART ── */}
          <OverviewHero
            userName={userName}
            timelineEntries={timelineEntries || []}
          />

          {timelineError && (
            <div
              style={{
                padding: "12px 16px",
                marginBottom: 16,
                borderRadius: 8,
                background: "rgba(239, 68, 68, 0.1)",
                border: "1px solid rgba(239, 68, 68, 0.3)",
                color: "#ef4444",
                fontSize: "0.85rem",
              }}
            >
              Failed to load real-time dashboard data.
            </div>
          )}

          {/* ── PHASE 1 SECTION: MOST AFFECTED NATIONS & INTERACTIVE WORLD THREAT MAP ── */}
          <MostAffectedNationsSection
            nations={nationsData?.nations || []}
            timeframe={nationsTimeframe}
            onTimeframeChange={setNationsTimeframe}
            loading={nationsLoading}
            isValidating={nationsValidating}
            error={nationsError ? "Failed to update geographic threat intelligence." : null}
          />

          {/* ── RANSOMWARE INTELLIGENCE SECTION ── */}
          <RansomwareSection />
        </div>
      </div>
    </div>
  );
}
